export default "__VITE_ASSET__BiQybmRo__"